import { NgModule } from '@angular/core';
import { AcceptTermsDialogPageModule } from './accept-terms-dialog/accept-terms-dialog.module';
import { BuyTicketPageModule } from './buy-ticket/buy-ticket.module';
import { LoginPageModule } from './login/login.module';
import { OrderHistoryPageModule } from './order-history/order-history.module';
import { ReceiptPageModule } from './receipt/receipt.module';
import { TermsPageModule } from './terms/terms.module';
import { TicketsPageModule } from './tickets/tickets.module';
import { TimetablePageModule } from './timetable/timetable.module';

@NgModule({
  declarations: [],
  imports: [
    BuyTicketPageModule,
    LoginPageModule,
    ReceiptPageModule,
    TicketsPageModule,
    TimetablePageModule,
    OrderHistoryPageModule,
    AcceptTermsDialogPageModule,
    TermsPageModule
  ]
})
export class PagesModule { }
